module.exports = __webpack_public_path__ + "img/form_submit.f20b0feb.svg";